import { render, staticRenderFns } from "./Usp.vue?vue&type=template&id=83a0dbb4&"
import script from "./Usp.vue?vue&type=script&lang=js&"
export * from "./Usp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports